import gql from 'graphql-tag';

export const CREATE_CHECKOUT_SESSION = gql`
  query CreateCheckoutSession($input:CheckoutSession) {
    createCheckoutSession(input: $input)
  }
`;

export const IS_EMAIL_AVAILABLE = gql`
  query IsEmailAvailable($input: String!) {
    isEmailAvailable(input: $input)
  }
`;

export const DOES_ACCOUNT_EXIST = gql`
  query DoesAccountExist {
    doesAccountExist
  }
`;
